import moment from "moment";
import "moment-timezone";
import Constants from "./constantsData";
import config from "../../build/config"
import Enum from "../../enum/enum";

const formatNumber = function(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

const currencyFormat = function(num) {
  return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

const floatFormat = function(num) {
  return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,"); // 12,345.67,
};

const addMonths = function(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + +months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
};

const formatInteger = function(num) {
  if (num.length > 3) {
    return num.replace(/,/g, ""); // 12,345 ==> 12345
  }
  return num;
};
//Check language
const isEnglishLanguage = function(locale) {
  if (locale == "vi") {
    return false;
  } else {
    return true;
  }
};
//Get full name
const getFullName = function(firstName, lastName, locale) {
  if (isEnglishLanguage(locale)) {
    //Get full name by vietnamese
    return (
      (isNull(firstName) ? "" : firstName) +
      " " +
      (isNull(lastName) ? "" : lastName)
    );
  } else {
    //Get full name by english
    return (
      (isNull(lastName) ? "" : lastName) +
      " " +
      (isNull(firstName) ? "" : firstName)
    );
  }
};
//Check is null
const isNull = function(data) {
  if (
    data == undefined ||
    data == null ||
    data.length == 0 ||
    data == 0 ||
    data == ""
  ) {
    return true;
  } else {
    return false;
  }
};

// [loitt] - add read VND
var array_number = [
  "Không",
  "Một",
  "Hai",
  "Ba",
  "Bốn",
  "Năm",
  "Sáu",
  "Bảy",
  "Tám",
  "Chín"
];
var array_number_change = [
  " Mươi",
  " Mốt",
  " Mười",
  " Một",
  " Lẻ",
  " Lăm",
  " Trăm",
  " Triệu",
  " Nghìn",
  " Tỷ"
];

const readDozens = function(number, full) {
  var result = "";
  let dozen = Math.floor(number / 10);
  let taste = number % 10;
  if (dozen > 1) {
    result = " " + array_number[dozen] + array_number_change[0]; // Mươi
    if (taste == 1) {
      result += array_number_change[1]; // Mốt
    }
  } else if (dozen == 1) {
    result = array_number_change[2]; // Mười
    if (taste == 1) {
      result += array_number_change[3]; // Một
    }
  } else if (full && taste > 0) {
    result = array_number_change[4]; // Lẻ
  }

  if (taste == 5 && dozen >= 1) {
    result += array_number_change[5]; // Lăm;
  } else if (taste > 1 || (taste == 1 && dozen == 0)) {
    result += " " + array_number[taste];
  }
  return result;
};

const readBlock = function(number, full) {
  var result = "";
  let tram = Math.floor(number / 100);
  number = number % 100;
  if (full || tram > 0) {
    result = " " + array_number[tram] + array_number_change[6]; //" Trăm";
    result += readDozens(number, true);
  } else {
    result = readDozens(number, false);
  }
  return result;
};

const readMillion = function(number, full) {
  var result = "";
  let million = Math.floor(number / 1000000);
  number = number % 1000000;
  if (million > 0) {
    result = readBlock(million, full) + array_number_change[7]; //" Triệu";
    full = true;
  }
  let thousand = Math.floor(number / 1000);
  number = number % 1000;
  if (thousand > 0) {
    result += readBlock(thousand, full) + array_number_change[8]; // " Nghìn";
    full = true;
  }
  if (number > 0) {
    result += readBlock(number, full);
  }
  return result;
};

// Read number to VN
const numToWordsVn = function(number) {
  if (number == 0) return array_number[0];
  var result = "",
    suffixes = "";
  do {
    let billions = number % 1000000000;
    number = Math.floor(number / 1000000000);
    if (number > 0) {
      result = readMillion(billions, true) + suffixes + result;
    } else {
      result = readMillion(billions, false) + suffixes + result;
    }
    suffixes = array_number_change[9]; // " Tỷ";
  } while (number > 0);
  return result;
};

// Process for read English
const arr = x => Array.from(x);
const num = x => Number(x) || 0;
const isEmpty = xs => xs.length === 0;
const take = n => xs => xs.slice(0, n);
const drop = n => xs => xs.slice(n);
const reverse = xs => xs.slice(0).reverse();
const comp = f => g => x => f(g(x));
const not = x => !x;
const chunk = n => xs =>
  isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))];

// numToWords :: (Number a, String a) => a -> String
// Read number to EN
let numToWordsEn = n => {
  let a = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen"
  ];

  let b = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety"
  ];

  let g = [
    "",
    "thousand",
    "million",
    "billion",
    "trillion",
    "quadrillion",
    "quintillion",
    "sextillion",
    "septillion",
    "octillion",
    "nonillion"
  ];

  // this part is really nasty still
  // it might edit this again later to show how Monoids could fix this up
  let makeGroup = ([ones, tens, huns]) => {
    return [
      num(huns) === 0 ? "" : a[huns] + " hundred ",
      num(ones) === 0 ? b[tens] : (b[tens] && b[tens] + "-") || "",
      a[tens + ones] || a[ones]
    ].join("");
  };

  let thousand = (group, i) => (group === "" ? group : `${group} ${g[i]}`);

  if (typeof n === "number") return numToWordsEn(String(n));
  else if (n === "0") return "zero";
  else
    return comp(chunk(3))(reverse)(arr(n))
      .map(makeGroup)
      .map(thousand)
      .filter(comp(not)(isEmpty))
      .reverse()
      .join(" ");
};

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const readMoney = function(number, locale) {
  let amount = "";
  if (typeof number == "undefined" || number == null) {
    return amount;
  }
  number = makeRoundNumber(number);
  if (isEnglishLanguage(locale)) {
    //Get full name by english
    let lower = numToWordsEn(number).toLowerCase();
    if (lower.length > 0) {
      amount = capitalize(lower.trim()) + " dongs";
    }
  } else {
    //Get full name by vietnamese
    let lower = numToWordsVn(number).toLowerCase();
    if (lower.length > 0) {
      amount = capitalize(lower.trim()) + " đồng";
    }
  }
  return amount;
};

const vatAmount = function(
  this_month_value,
  last_month_value,
  VAT,
  price_unit
) {
  let total_fees = (this_month_value - last_month_value) * price_unit;
  let vat_amount = makeRoundNumber((total_fees * VAT) / 100);
  let total_after_vat = vat_amount + total_fees;
  return [vat_amount, total_fees, total_after_vat];
};

const makeRoundNumber = function(num, decimalPlaces = 0) {
  var p = Math.pow(10, decimalPlaces);
  return Math.round(num * p) / p;
};

const capitalizeFirstInString = function(str) {
  var array = str.toLowerCase().split(" ");
  var newarray = [];

  for (var x = 0; x < array.length; x++) {
    newarray.push(array[x].charAt(0).toUpperCase() + array[x].slice(1));
  }
  return newarray.join(" ");
};

const validateEmailAddress = function(emailAddress) {
  const regex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
  return regex.test(emailAddress) ? true : false;
};

const validatePhone = function(phone) {
  const regex = /^(0[3|5|7|8|9][0-9]{8}|[+]84[3|5|7|8|9][0-9]{8})$/;
  return regex.test(phone) ? true : false;
};

const formatPhoneWithSpace = function(phone, defValue = null) {
  if (!isNull(phone)) {
    phone = String(phone).replace(/\./g, "");
    if (String(phone).charAt(0) == "+") {
      return (
        phone.slice(0, 3) + " " +
        phone.slice(3, 5) + " " +
        phone.slice(5, 8) + " " +
        phone.slice(8)
      );
    } else {
      return phone.slice(0, 3) + " " + phone.slice(3, 6) + " " + phone.slice(6);
    }
  }
  return defValue
};

const jsUcFirst = function(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

const ucFirstAllWords = function(str) {
  var pieces = str.split(" ");
  for (var word = 0; word < pieces.length; word++) {
    var theFirstCharacterUpper = pieces[word].charAt(0).toUpperCase();
    pieces[word] = theFirstCharacterUpper + pieces[word].slice(1).toLowerCase();
    //pieces[word] = theFirstCharacterUpper + pieces[word].substr(1);
  }
  return pieces.join(" ");
};

const has_perm = function(loggin_info, perm) {
  let perms = loggin_info.permissions;
  for (let i = 0; i < perms.length; i++) {
    let current_perm = perms[i];
    if (current_perm === perm) {
      return true;
    }
  }
  return false;
};

const getDatesBetweenTwoDate = function(startDate, endDate, dateFormat) {
  var dateArray = [];
  var currentDate = moment(moment(startDate, dateFormat));
  var stopDate = moment(moment(endDate, dateFormat));
  while (currentDate <= stopDate) {
    dateArray.push(moment(currentDate).format(dateFormat));
    currentDate = moment(currentDate).add(1, "months");
  }
  return dateArray;
};
//Get date array between two date
const getDaysBetweenTwoDate = function(startDate, endDate, dateFormat) {
  var dateArray = [];
  var currentDate = moment(moment(startDate, dateFormat));
  var stopDate = moment(moment(endDate, dateFormat));
  while (currentDate <= stopDate) {
    dateArray.push(moment(currentDate).format(dateFormat));
    currentDate = moment(currentDate).add(1, "days");
  }
  return dateArray;
};

const getApplicationName = function(applicationTypes, id) {
  var text;
  applicationTypes.forEach(v => {
    if (v.value === id) {
      text = v.text;
      return true;
    }
  });
  return text;
};

const convertFormatNumberToMoney = function(number) {
  return (
    Number(number)
      .toFixed(0)
      .replace(/./g, function(c, i, a) {
        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "." + c : c;
      }) + " VNĐ"
  );
};

// Check is number
// const isNumeric = function(num) {
//   return !isNaN(num)
// }

const isNumeric = function(value) {
  return /^-{0,1}\d+$/.test(value);
};

//
// [loitt]
// function: Sleep
// @param : ms
//
const sleep = function(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
};

const removeSpecialCharacter = function(str) {
  if (this.isNull(str)) return 0;
  return str.replace(/[^a-zA-Z0-9]/g, "");
};

const datediff = function(first, second) {
  //return Math.round((second-first)/(1000*60*60*24));
  var date1 = new Date(first);
  var date2 = new Date(second);

  // To calculate the time difference of two dates
  var Difference_In_Time = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return Difference_In_Days;
};

const compareTwoDate = function(date1, date2, dateFormat) {
  if (moment(date1).isAfter(moment(date2))) {
    return 1;
  } else if (moment(date1).isBefore(moment(date2))) {
    return -1;
  } else {
    return 0;
  }
};

const addTimeZoneForTimestamp = function(date, toFormat = null) {
  let timeZone = Constants.timeZone.Vietnamese;
  let ret = moment(date).tz(timeZone);
  if (toFormat === null) return ret
  return ret.format(toFormat)
};

const formatDateTime = function(date, fromFormat, toFormat) {
  if (isNull(date)) {
    return "";
  }
  if (moment(date, "DD/MM/YYYY").format(toFormat) == "Invalid date") {
    return moment(date, fromFormat).format(toFormat);
  }
  return moment(date, "DD/MM/YYYY").format(toFormat);
};

const formatDateTimeWithHour = function(date, fromFormat, toFormat) {
  if (isNull(date)) {
    return "";
  }
  if (moment(date, toFormat).format(toFormat) == "Invalid date") {
    return moment(date, fromFormat).format(toFormat);
  }
  return moment(date, toFormat).format(toFormat);
};

const formatSqlDate = function(date, fromFormat, toFormat, defValue=null) {
  if (!isEmptyString(date)) {
    if (isNull(fromFormat)) {
      return moment(date).format(toFormat)
    }
    if (isNull(toFormat)) {
      return moment(date, fromFormat)
    }
    return moment(date, fromFormat).format(toFormat)
  }
  return defValue
};

const formatSqlUtcDate = function(date, fromFormat, toFormat) {
  if (!isEmptyString(date)) {
    return moment(date, fromFormat).utc().format(toFormat)
  }
  return null
}

const formatSqlUtcStartOfDate = function(date, fromFormat, toFormat) {
  if (!isEmptyString(date)) {
    return moment(date, fromFormat).startOf("day").utc().format(toFormat)
  }
  return null
}

const formatSqlUtcEndOfDate = function(date, fromFormat, toFormat) {
  if (!isEmptyString(date)) {
    return moment(date, fromFormat).endOf("day").utc().format(toFormat)
  }
  return null
}

const getAccountingPeriodFromDate = function(date, fromFormat) {
  let out = null
  if (!isEmptyString(date)) {
    if (isNull(fromFormat)) {
      out = moment(date)
    } else {
      out = moment(date, fromFormat)
    }
  }
  return {
    'month': out != null ? out.month() + 1 : null,
    'year': out != null ? out.year() : null,
  }
}

// Author: [loitt]
// get by length UTF8
const byteLength = function(str) {
  // returns the byte length of an utf8 string
  if (this.isNull(str)) return 0;
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
};
//
// const getBackEndURL = function() {
//   let server_base_url = location.origin;
//   server_base_url = server_base_url.replace(
//     location.hostname,
//     configuration.backendConfig.hostname
//   );
//   if (location.port) {
//     server_base_url = server_base_url.replace(
//       location.port,
//       configuration.backendConfig.port
//     );
//   }
//   if (configuration.backendConfig.subpath) {
//     server_base_url =
//       server_base_url + "/" + configuration.backendConfig.subpath;
//   }
//   return server_base_url;
// };

const getPeriodicURL = function() {
  let server_base_url = config.BACKEND_URL;
  let periodic_url =
    server_base_url + "/admin/django_celery_beat/periodictask/";
  return periodic_url;
};

const getToDay = function() {
  let today = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = today.getFullYear();

  today = dd + "-" + mm + "-" + yyyy;
  return today;
};

const getFirstLastName = function (fullName) {
  // Split full name to get last name and first name
  let fullNameArray = fullName.split(' ')
  let firstName = fullNameArray[fullNameArray.length - 1]
  let lastName = ''
  for (let i = 0, size = fullNameArray.length - 1; i < size; i++) {
    lastName += fullNameArray[i] + (i < size - 1 ? ' ' : '')
  }
  return {
    'firstName': firstName,
    'lastName': lastName
  }
}

const getCleanStringValue = function (value, defValue=null) {
  if ((value === undefined) || (value === null)) return defValue
  if (typeof value === 'string') {
    value = value.trim()
    return value.length === 0 ? defValue : value
  }
  return value
}

const isEmptyString = function (value) {
  return (value === undefined) || (value === null) || (typeof value === 'string' && value.trim().length === 0)
}

/**
 * Change alias
 * @param {*} str 
 */
 const changeAlias = function (str) {
  if (!isEmptyString(str)) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, "d").replace(/Đ/g, "D");
  }
  return ''
}

const replaceCharactersVNLanguage = function(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

const spliceString = function(strText, len){
  if (isEmptyString(strText)) return null
  const truncate = (str, len) => str.substring(0, (str + ' ').lastIndexOf(' ', len));
  if(strText.length > len){
    return truncate(strText, len)+ '...';
  }
  else return strText;
}

const getProjectSession = function() {
  let projectId = sessionStorage.getItem('projectId')
  if (projectId) {
    return projectId
  }
  return null
}

const getProjectId = function() {
  let projectId = sessionStorage.getItem('projectId')
  if (!isNull(projectId)) {
    return projectId
  }
  return 0
}

const getSessionKeyString = function (key, defValue = '') {
  let sessionValue = sessionStorage.getItem(key)
  if (isNull(sessionValue) || (sessionValue === 'undefined') || (sessionValue === 'null')) {
    return defValue
  }
  return sessionValue
}

const getSessionKeyInt = function (key, defValue = 0) {
  let sessionValue = sessionStorage.getItem(key)
  if (isNull(sessionValue) || (sessionValue === 'undefined') || (sessionValue === 'null')) {
    return defValue
  }
  return parseInt(sessionValue)
}

const getSessionKeyBool = function (key, defValue = false) {
  let sessionValue = sessionStorage.getItem(key)
  if (isNull(sessionValue) || (sessionValue === 'undefined') || (sessionValue === 'null')) {
    return defValue
  }
  if (sessionValue == 'false') return false
  if (sessionValue == 'true') return true
  return defValue
}

const isAdmin = function(userInfo) {
  let group_id = userInfo.group_id
  return group_id === 1 ? true : false
}

const isSuperAdmin = function(userInfo) {
  let id = userInfo.id
  return id === 1 ? true : false
}

const getPrivilegeRole = function(userInfo, privilegeId) {
  let privilege_id = userInfo.privilege_id
  return privilege_id === privilegeId ? true : false
}

const getGender = function(gender) {
  if (gender === null) {
    return null
  }
  if (gender == 1) {
    return 'customer.gender_type[0]'
  } else if (gender == 2) {
    return 'customer.gender_type[1]'
  } else {
    return 'customer.gender_type[2]'
  }
}

const getInvoiceTypeString = function(type) {
  if (type === Enum.invoiceTypeEnum.MONTHLY) {
    return 'invoice.monthlyFee'
  } else if (type === Enum.invoiceTypeEnum.QUATERLY) {
    return 'invoice.managementFee'
  } else if (type === null || type === undefined) {
    return ''
  }
  return 'common.undefined'
}

import ImportFromExcelEnum from "../enum/importFromExcelEnum"
const getStatusImportExcel = function(value) {
  if (value === null) {
    return null
  }
  if (value === ImportFromExcelEnum.PASS) {
    return 'invoice.importExcel.statusList.PASS'
  }
  else if (value === ImportFromExcelEnum.ERROR) {
    return 'invoice.importExcel.statusList.ERROR'
  }
  else if (value === ImportFromExcelEnum.EXISTS) {
    return 'invoice.importExcel.statusList.EXISTS'
  }
  else {
    return value
  }
}

const checkEnableModuleOrExtraInfo = function(resultGetter, isModule, key) {
  if (isModule) {
    if (resultGetter.module_array !== undefined && 
      resultGetter.module_array.includes(key))
    {
      return true
    }
  } else {
    if (resultGetter.extra_info_list !== undefined && 
      resultGetter.extra_info_list.includes(key))
    {
      return true
    }
  }
  return false
}

import NotificationCategoryEnum from "@/enum/notificationCategoryEnum";
const getTemplateCatagoryName = function(category) {
  if (category == NotificationCategoryEnum.ELECTRIC_AND_WATER_INVOICE) {
    return "templateNotification.template.electric_and_water_invoice"
  } else if (category == NotificationCategoryEnum.MANAGEMENT_SERVICE) {
    return "templateNotification.template.management_service"
  } else if (category == NotificationCategoryEnum.SEND_EVENT_TO_CUSTOMER) {
    return "templateNotification.template.send_event_to_customer"
  } else if (category == NotificationCategoryEnum.NEW_FEEDBACK) {
    return "templateNotification.template.new_feedback"
  } else if (category == NotificationCategoryEnum.FEEDBACK_ASSIGN_TO_PROCESSCOR) {
    return "templateNotification.template.feedback_assign_to_processcor"
  } else if (category == NotificationCategoryEnum.STAFF_COMPLETE_FEEDBACK) {
    return "templateNotification.template.staff_complete_feedback"
  } else if (category == NotificationCategoryEnum.STAFF_CANCEL_FEEDBACK) {
    return "templateNotification.template.staff_cancel_feedback"
  } else if (category == NotificationCategoryEnum.FEEDBACK_COMPLETE_SEND_TO_CUSTOMER) {
    return "templateNotification.template.feedback_complete_send_to_customer"
  } else if (category == NotificationCategoryEnum.FEEDBACK_CANCEL_SEND_TO_CUSTOMER) {
    return "templateNotification.template.feedback_cancel_send_to_customer"
  }
  return ""
}

import EmailTemplateCategoryEnum from "@/enum/emailTemplateCategoryEnum";
const getEmailTemplateCatagoryName = function(category) {
  if (category == EmailTemplateCategoryEnum.ELECTRIC_AND_WATER_INVOICE) {
    return "templateNotification.emailTemplate.electric_and_water_invoice"
  } else if (category == EmailTemplateCategoryEnum.MANAGEMENT_SERVICE) {
    return "templateNotification.emailTemplate.management_service"
  }
  return ""
}

import ContractStatusEnum from "@/enum/contractStatusEnum";
const getContractStatusName = function(status) {
  if (status == ContractStatusEnum.BOOK) {
    return "contract.status_book"
  } else if (status == ContractStatusEnum.DEPOSIT) {
    return "contract.status_deposit"
  } else if (status == ContractStatusEnum.CONTRACT) {
    return "contract.status_contract"
  } else if (status == ContractStatusEnum.END_CONTRACT) {
    return "contract.status_end_contract"
  }
  return ""
}

import RealestateTypeEnum from "@/enum/realestateTypeEnum";
const getRealestateTypeName = function(type) {
  if ( type == RealestateTypeEnum.VILLA) {
    return "apartment_realestate.class.villa"
  } else if ( type == RealestateTypeEnum.APARTMENT) {
    return "apartment_realestate.class.apartment"
  } else if ( type == RealestateTypeEnum.GROUND) {
    return "apartment_realestate.class.ground"
  }
  return ""
}

import RelativeRelationshipEnum from "@/enum/relativeRelationshipEnum";
const getRelationshipName = function(relation) {
  if (relation == RelativeRelationshipEnum.GRANDPA) {
    return "customer.relationship.grandpa"
  } else if (relation == RelativeRelationshipEnum.GRANDMA) {
    return "customer.relationship.grandma"
  } else if (relation == RelativeRelationshipEnum.FATHER) {
    return "customer.relationship.father"
  } else if (relation == RelativeRelationshipEnum.MOTHER) {
    return "customer.relationship.mother"
  } else if (relation == RelativeRelationshipEnum.CHILD) {
    return "customer.relationship.child"
  } else if (relation == RelativeRelationshipEnum.WIFE) {
    return "customer.relationship.wife"
  } else if (relation == RelativeRelationshipEnum.HUSBAND) {
    return "customer.relationship.husband"
  } else if (relation == RelativeRelationshipEnum.DAUGHTER) {
    return "customer.relationship.daughter"
  } else if (relation == RelativeRelationshipEnum.SON) {
    return "customer.relationship.son"
  } else if (relation == RelativeRelationshipEnum.GRANDCHILD) {
    return "customer.relationship.grandchild"
  } else if (relation == RelativeRelationshipEnum.OLDER_SISTER) {
    return "customer.relationship.older_sister"
  } else if (relation == RelativeRelationshipEnum.OLDER_BROTHER) {
    return "customer.relationship.older_brother"
  } else if (relation == RelativeRelationshipEnum.YOUNGER_SISTER) {
    return "customer.relationship.younger_sister"
  } else if (relation == RelativeRelationshipEnum.YOUNGER_BROTHER) {
    return "customer.relationship.younger_brother"
  }
  return ""
}

import PackageTypeEnum from "@/enum/packageTypeEnum";
const getPackageTypeName = function(type) {
  if (type == PackageTypeEnum.LUXURY) {
    return "service.package.luxury"
  } else if (type == PackageTypeEnum.DELUXE) {
    return "service.package.deluxe"
  } else if (type == PackageTypeEnum.PREMIUM) {
    return "service.package.premium"
  } else if (type == PackageTypeEnum.STANDARD) {
    return "service.package.standard"
  }
  return ""
}

export default {
  formatNumber,
  currencyFormat,
  floatFormat,
  isEnglishLanguage,
  formatInteger,
  isNull,
  getFullName,
  readMoney,
  vatAmount,
  makeRoundNumber,
  capitalizeFirstInString,
  capitalize,
  validatePhone,
  formatPhoneWithSpace,
  jsUcFirst,
  ucFirstAllWords,
  has_perm,
  getDatesBetweenTwoDate,
  getApplicationName,
  convertFormatNumberToMoney,
  isNumeric,
  sleep,
  removeSpecialCharacter,
  datediff,
  compareTwoDate,
  addTimeZoneForTimestamp,
  formatDateTime,
  formatDateTimeWithHour,
  formatSqlDate,
  formatSqlUtcDate,
  formatSqlUtcStartOfDate,
  formatSqlUtcEndOfDate,
  getAccountingPeriodFromDate,
  byteLength,
  getDaysBetweenTwoDate,
  getPeriodicURL,
  getToDay,
  validateEmailAddress,
  addMonths,
  getFirstLastName,
  isEmptyString,
  getCleanStringValue,
  changeAlias,
  replaceCharactersVNLanguage,
  spliceString,
  getProjectSession,
  getProjectId,
  getSessionKeyString,
  getSessionKeyInt,
  getSessionKeyBool,
  isAdmin,
  isSuperAdmin,
  getPrivilegeRole,
  getGender,
  getInvoiceTypeString,
  getStatusImportExcel,
  checkEnableModuleOrExtraInfo,
  getTemplateCatagoryName,
  getEmailTemplateCatagoryName,
  getContractStatusName,
  getRealestateTypeName,
  getRelationshipName,
  getPackageTypeName
};



// WEBPACK FOOTER //
// ./src/lib/utils.js